import React, { useEffect, useState } from 'react';
import Shoot from '../../../../layout/Shoot';
import { Box, Container, Grid, CircularProgress, Typography, Button, useTheme } from '@mui/material';
import { CommonHeading, CommonTitle } from '../../../../layout/Common';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const StylishMaterials = ({ onLoaded, AllProduct }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    // const [AllProduct, setAllProduct] = useState([]);

    // const fetchAllProducts = async () => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetAllProduct?page=1&limit=6`);
    //         setAllProduct(response.data.data);
    //     } catch (error) {
    //         console.error('Error fetching products:', error);
    //     } finally {
    //         onLoaded();
    //     }
    // };

    // useEffect(() => {
    //     fetchAllProducts();
    // }, []);

    return (
        <Box sx={{
            backgroundImage: 'url(/images/Stylish-Materials/product-bg.jpg)',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'relative',
            zIndex: '1',
            backgroundAttachment: 'fixed',
            py: { sm: 19, xs: 5 },
            '&::before': {
                content: '""',
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: '-1',
                backgroundColor: '#000000c7',
                top: '0'
            }
        }}>
            <Box sx={{ textAlign: 'center', pb: 6, }}>
                <CommonTitle margin={'0 0 10px 0'} text={'recent products'} />
                <CommonHeading text={'Enduringly Stylish Materials'} />
            </Box>
            <Container maxWidth='xl'>
                <Grid container spacing={3} justifyContent="center" alignItems="center">
                    {AllProduct.length > 0 ? (
                        AllProduct.map((val, index) => (
                            <Grid key={index} item xs={12} sm={6} md={4}>
                                <Shoot
                                    primaryImg={val?.ProductImage}
                                    title={val?.ClothesType}
                                    price={val.ProductPrice}
                                    ShirtMeter={val?.ShirtMeter}
                                    PaintMeter={val?.PaintMeter}
                                    FabricType={val?.FabricType} 
                                    TrouserMeter={val?.TrouserMeter} 
                                    KurtaMeter={val?.KurtaMeter}
                                    DiscountPrice={val?.DiscountPrice}
                                    slug={val.unqid}
                                    imageHeight={"500px"}
                                    TitlefontSize={'20px'}
                                    Pricefontsize={'16px'}
                                    buttonwidth={'50%'}
                                />
                            </Grid>
                        ))
                    ) : (
                        <Grid item xs={12}>
                            <Box sx={{ textAlign: 'center', py: 6, color: 'white' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    No Products Available
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        textTransform: 'uppercase',
                        border: '1px solid #BB9D7B',
                        borderRadius: '0',
                        color: '#fff',
                        padding: '10px 30px',
                        marginTop: '10px',
                        zIndex: 1,
                        width: { md: '20%', xs: '40%' },
                        transition: 'all 0.3s linear 0s',
                        fontFamily: theme.palette.typography.fontFamily1,
                        color: '#BB9D7B'
                        , '&:hover': {
                            backgroundColor: theme.palette.primary.gold,
                            color: theme.palette.primary.main
                        }
                    }}
                    onClick={()=> navigate('/gallery')}
                    >View all</Button>
                </Box>
            </Container>
        </Box>
    );
};

export default StylishMaterials;
